import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import './reset.scss';

import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import SignUpFormCheckboxLayout from '../../../layouts/SignUp/SignUpFormCheckboxLayout';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';

class ChangePasswordComponent extends React.Component {
    componentWillMount() {
        this.props.checkLinkToken();
    }

    render() {
        const { handleSubmit, onCancel, isLoading, isChangePasswordAction, old } = this.props;
        const confirmPlaceholder = `Retype ${isChangePasswordAction ? 'new' : ''} password`;

        if (old) {
            handleSubmit();
            return <Redirect to={`/profile/companies`} />;
        }

        return <div className="change-password container">
            {isLoading && <LoadingComponent fullScreen />}
            <h2>{isChangePasswordAction ? 'Change password' : 'Complete your invitation'}</h2>
            <Form onSubmit={handleSubmit}>
                <FieldGroupComponent
                    label={isChangePasswordAction ? 'New password' : 'Password'}
                    name="password"
                    type="password"
                    placeholder={`Enter ${isChangePasswordAction ? 'new' : ''} password`}
                    formProps={{
                        maxLength: 16,
                    }}
                />
                <FieldGroupComponent
                    label={confirmPlaceholder}
                    name="confirmPassword"
                    type="password"
                    placeholder={confirmPlaceholder}
                    formProps={{
                        maxLength: 16,
                    }}
                />
                {!isChangePasswordAction &&
                    <SignUpFormCheckboxLayout />
                }
                <div className="buttons">
                    <Button type="submit">{isChangePasswordAction ? 'Submit' : 'Complete'}</Button>
                    <Button className="dark" onClick={onCancel}>Cancel</Button>
                </div>
            </Form>
        </div>;
    }
}

ChangePasswordComponent.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    checkLinkToken: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isChangePasswordAction: PropTypes.bool.isRequired,
    old: PropTypes.bool,
};

export default ChangePasswordComponent;



// WEBPACK FOOTER //
// ./src/components/login/resetPassword/ChangePasswordComponent.js